// reducers/blogReducer.js
import {
  CREATE_BLOG_REQUEST,
  CREATE_BLOG_SUCCESS,
  CREATE_BLOG_FAIL,
  GET_ALL_BLOGS_REQUEST,
  GET_ALL_BLOGS_SUCCESS,
  GET_ALL_BLOGS_FAIL,
  GET_BLOG_BY_ID_REQUEST,
  GET_BLOG_BY_ID_SUCCESS,
  GET_BLOG_BY_ID_FAIL,
} from "../constants/blogConstant";

export const createBlogReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_BLOG_REQUEST:
      return { ...state, loading: true };

    case CREATE_BLOG_SUCCESS:
      return { ...state, loading: false, blog: action.payload };

    case CREATE_BLOG_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getAllBlogsReducer = (state = { allBlogs: [] }, action) => {
  switch (action.type) {
    case GET_ALL_BLOGS_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_BLOGS_SUCCESS:
      return { ...state, loading: false, allBlogs: action.payload };

    case GET_ALL_BLOGS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getBlogDetailsReducer = (state = { blog: null }, action) => {
  switch (action.type) {
    case GET_BLOG_BY_ID_REQUEST:
      return { ...state, loading: true };

    case GET_BLOG_BY_ID_SUCCESS:
      return { ...state, loading: false, blog: action.payload };

    case GET_BLOG_BY_ID_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
